import React from 'react';
import { Colors } from '../../constants';

const LocationIcon = ({ customClass, color = `${Colors.blackText}` }) => {
  return(
    <svg width="14" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 8.77519C16 14.6192 8.5 19.6283 8.5 19.6283C8.5 19.6283 1 14.6192 1 8.77519C1 6.78243 1.79018 4.87128 3.1967 3.46219C4.60322 2.0531 6.51088 1.26147 8.5 1.26147C10.4891 1.26147 12.3968 2.0531 13.8033 3.46219C15.2098 4.87128 16 6.78243 16 8.77519Z" 
        stroke={`#${ color }`} 
        strokeLinecap="round" 
        strokeLinejoin="round"
        className={`svg-icon-custom ${customClass || ''}`} />
      <path d="M8.5 11.2798C9.88071 11.2798 11 10.1584 11 8.7752C11 7.39196 9.88071 6.27063 8.5 6.27063C7.11929 6.27063 6 7.39196 6 8.7752C6 10.1584 7.11929 11.2798 8.5 11.2798Z" 
        stroke={`#${ color }`} 
        strokeLinecap="round"
        strokeLinejoin="round"
        className={`svg-icon-custom ${customClass || ''}`} />
    </svg>
  );
};

export default LocationIcon;